export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            'textures/environmentMap/px.jpg',
            'textures/environmentMap/nx.jpg',
            'textures/environmentMap/py.jpg',
            'textures/environmentMap/ny.jpg',
            'textures/environmentMap/pz.jpg',
            'textures/environmentMap/nz.jpg'
        ]
    },
    {
        name: 'saunaModel',
        type: 'gltfModel',
        path: 'models/Sauna/gaikiyoku.glb'
    },
    {
        name: 'mizuburoModel',
        type: 'gltfModel',
        path: 'models/Mizuburo/Mizuburo.gltf'
    },
    {
        name: 'afroModel',
        type: 'gltfModel',
        path: 'models/Afro/Afro.gltf'
    }
]